import { useEffect, useRef } from 'react';
import Shake from 'shake.js';

interface UseShakeOptions {
    onShake: () => void,
    enabled: boolean, // Điều khiển bật/tắt shake detection
    threshold?: number,
    timeout?: number
}

const UseShakeDetection = ({ onShake, enabled, threshold = 15, timeout = 1000 }: UseShakeOptions) => {
    const shakeEventRef = useRef<Shake | null>(null);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        if (enabled) {
            shakeEventRef.current = new Shake({ threshold, timeout });
            shakeEventRef.current.start();
            window.addEventListener('shake', onShake, false);
        } else {
            if (shakeEventRef.current) {
                shakeEventRef.current.stop();
                window.removeEventListener('shake', onShake, false);
            }
        }

        return () => {
            if (shakeEventRef.current) {
                shakeEventRef.current.stop();
                window.removeEventListener('shake', onShake, false);
            }
        };
    }, [enabled, onShake, threshold, timeout]);
};

export default UseShakeDetection;
